import { Injectable } from '@angular/core';
import { AccountService } from './account/account.service';

@Injectable({
  providedIn: 'root'
})
export class SetCpoStationService {
    localCpolist: any[];
    localStationlist: any[];
    clientCpoStaDetail: any;
    localStorage:any;
    cpoStation = false;
    localClient:any;
    constructor(private accountService:AccountService) { 
        this.localStorage = JSON.parse(localStorage.getItem('userDetails'));
    }
  
      setCpoStationDetails(client_id){
        localStorage.removeItem("CpoList"); 
    localStorage.removeItem("StationList"); 
    let params:any;
    if(this.localStorage.role_code == 'CPO'){
       params = {
        cpo_id :this.localStorage.cpo_id
      }
    }else{
       params = { };
    }
   

    this.localCpolist = [];
    this.localStationlist = []; 

    this.accountService.cpoStationDetailsByClientId(this.localStorage.userId, client_id, params).subscribe(
      (resp: any) => {
        if (resp.status == true) {
          this.clientCpoStaDetail = resp.data;
          localStorage.setItem('clientCpoStaDetails', JSON.stringify(this.clientCpoStaDetail));

          for (var i = 0; i < this.clientCpoStaDetail.cpos.length; i++) {
            var cpoList = {
              cpo_id: this.clientCpoStaDetail.cpos[i].cpo_id,
              cpo_name: this.clientCpoStaDetail.cpos[i].cpo_name,
            }
            if (!this.localCpolist.find(c => c.cpo_id === this.clientCpoStaDetail.cpos[i].cpo_id)) {
              this.localCpolist.push(cpoList);
            }
          }
          for (var i = 0; i < this.clientCpoStaDetail.stations.length; i++) {
            var stationList = {
              cpo_id: this.clientCpoStaDetail.stations[i].cpo_id,
              cpo_name: this.clientCpoStaDetail.stations[i].cpo_name,
              station_id: this.clientCpoStaDetail.stations[i].station_id,
              station_name: this.clientCpoStaDetail.stations[i].station_name,
            }
            if (!this.localCpolist.find(st => st.station_id === this.clientCpoStaDetail.stations[i].station_id)) {
              this.localStationlist.push(stationList);
            }

          }
          localStorage.setItem('CpoList', JSON.stringify(this.localCpolist));
          localStorage.setItem('StationList', JSON.stringify(this.localStationlist));
            localStorage.setItem('selectedClient',client_id)
          this.cpoStation = true;
          return true;
        } else {
          var error = resp.message;
          return false;
         
        }
      }, (err) => {
        return  false;
       }
    );
  }
}
  
  
   
  
  